import { intersectRoles } from './auth-helpers'
import { UserRole } from './../../common/types/Irmao'
import { NavigationGuard, Route } from 'vue-router'

import { authModule, userModule } from '@/store'
import { TokenPayload } from 'common/types/Token'
export const authGuard: NavigationGuard = (to, from, next) => {
	const restricao = authModule.restricao
	switch (restricao) {
		case 'revalidar-palavra': return next({ name: 'revalidacao-de-palavra' })
		case 'aceitar-termos': return next({ name: 'aceite-de-termos' })
	}

	if (!authModule.isAuth) {
		return next({ name: 'login'})
	}

	if (authModule.éVisitante && !visitantePodeAcessar(to)) {
		return next({ name: 'home' })
	}

	next()
}

function visitantePodeAcessar(rota: Route) {
	if (!rota.meta?.permiteVisitante) return false
	if (rota.name === 'detalhar-irmao') return authModule.podeAbrirPerfil(rota.params.id)
	return true
}

export const roleGuard = (role: UserRole | UserRole[]): NavigationGuard => (to, from, next) => {
	if (!authModule.isAuth || !authModule.role) {
		next({ name: 'login'})
	} else if (!intersectRoles(role, authModule.role)) {
		next({ name: 'home'})
	} else {
		next()
	}
}

export const secretarioDeInformaticaGuard: NavigationGuard = (to, from, next) => {
	const { currentUser } = userModule
	if (!authModule.isAuth) {
		next({ name: 'login' })
	} else if (!currentUser || currentUser.role === 'Visitante' || !currentUser.secretarioDeInformatica) {
		next({ name: 'home' })
	} else {
		next()
	}
}

/** quem entrou pelo CIM sem e-mail ou com o e-mail ainda aguardando confirmação */
export const associarEmailGuard: NavigationGuard = (to, from, next) => {
	if (authModule.isAuth && (authModule.emailPendente || authModule.sugerirEmail)) return next()
	next({ name: authModule.isAuth ? 'home' : 'login' })
}

export const noAuthGuard: NavigationGuard = (to, from, next) => {
	if (authModule.isAuth) {
		next({ name: 'home'})
	} else {
		next()
	}
}

export const restricaoGuard = (restricao: TokenPayload['restricao']): NavigationGuard  => (to, _from, next) => {
	if (!authModule.usuarioTemporario || authModule.restricao !== restricao) {
		next({ name: 'login' })
	} else {
		next()
	}
}
